import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from '../entity';
import { DataColumn } from './dataColumn';
import { DataRow } from './dataRow';
import { DataRequest } from './dataRequest';

@JsonObject('Analytics')
export class Analytics extends Entity {
  @JsonProperty('columns', [DataColumn])
  public columns?: DataColumn[] = undefined;
  @JsonProperty('rows', [DataRow])
  public rows?: DataRow[] = undefined;
  @JsonProperty('totalRows', Number)
  public totalRows?: number = undefined;
  @JsonProperty('request', DataRequest)
  public request?: DataRequest = undefined;
}

